import { useState, useEffect } from 'react'
import {
   Alert,
   Button,
   CircularProgress,
   Container,
   Typography,
} from '@mui/material'
import { jwtDecode } from 'jwt-decode'
import { useNavigate } from 'react-router-dom'
import Countdown from 'react-countdown'

export default function ExamStart() {
   const token = sessionStorage.getItem('exam_token')
   const [loading, setLoading] = useState(true)
   const [message, setMessage] = useState(null)
   const navigate = useNavigate()

   useEffect(() => {
      if (token) {
         try {
            const decoded = jwtDecode(token)
            setMessage({
               type: 'success',
               text: `Selamat datang ${decoded.name}`,
            })
         } catch (e) {
            setMessage({
               type: 'error',
               text: 'Pastikan Anda sudah registrasi dengan benar',
            })
         }
      } else {
         setMessage({ type: 'error', text: 'Pastikan Anda sudah registrasi' })
      }
      setLoading(false)
   }, [token])

   const fetchExamQuestions = () => {
      navigate('/exam/questions')
   }

   // Custom renderer supaya bisa kontrol saat selesai
   const renderer = ({ minutes, seconds, completed }) => {
      if (completed) {
         return <span>Mengalihkan ke halaman ujian...</span>
      } else {
         return (
            <span>
               Otomatis start ujian dalam {minutes}:
               {seconds.toString().padStart(2, '0')}
            </span>
         )
      }
   }

   return (
      <Container sx={{ mt: 5, textAlign: 'center' }}>
         {loading ? (
            <CircularProgress />
         ) : (
            message && (
               <>
                  <Alert severity={message.type}>
                     <Typography variant="h6">{message.text}</Typography>
                  </Alert>

                  {message.type === 'success' && (
                     <Button onClick={fetchExamQuestions}>Start Exam</Button>
                  )}

                  <Countdown
                     onComplete={() => fetchExamQuestions()}
                     date={Date.now() + 10 * 1000} // 1 menit
                     renderer={renderer}
                  />
               </>
            )
         )}
      </Container>
   )
}
